const smoothScroll = (function ($) {

  const pub = {};

  pub.init = function () {
    pub._anchorScroll();
    pub._loadScroll();
  };

  /**
   * Handle clicking of anchor tags with hash
   * Only proceed to animate if meets criteria
   */
  pub._anchorScroll = function () {
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .not('[data-toggle]')
      .click(function (event) {
        // On-page links only
        if (
          location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
          &&
          location.hostname === this.hostname
        ) {
          // Figure out element to scroll to
          let target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

          if (target.length) {
            event.preventDefault();
            pub._scrollAnimate(target);
          }
        }
      });
  };

  /**
   * Handle page load of page with hash
   */
  pub._loadScroll = function () {
    if (!window.location.hash) {
      return false;
    }

    pub._scrollAnimate($(window.location.hash));
  };

  /**
   * Handle animation to specified target on page
   *
   * @param {object} target 
   */
  pub._scrollAnimate = function(target) {
    if (!target.length) {
      return false;
    }

    // Figure out scrollTop amount
    const navObject = $('.site-navigation');
    const navHeight = navObject.height();
    const navOffset = navObject.position().top;
    const targetScrollTop = target.offset().top - navHeight - navOffset;

    $('html, body').animate({
      scrollTop: targetScrollTop
    }, 500, function () {
      // Callback after animation
      // Must change focus!
      const $target = $(target);
      $target.focus();
      if ($target.is(":focus")) { // Checking if the target was focused
        return false;
      } else {
        $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
        $target.focus(); // Set focus again
      };
    });
  };

  return pub;

})(jQuery);
